export enum SupportV2CountVerificationStatus {
  Pending = "pending",
  WithinTolerance = "within_tolerance",
  CountMismatch = "count_mismatch",
  Error = "error",
}
